import { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Prefissi internazionali più comuni; Italia prima (default). Nomi in lingua nativa. */
const COUNTRIES = [
  { code: "it", dial: "+39", name: "Italia" },
  { code: "gb", dial: "+44", name: "United Kingdom" },
  { code: "us", dial: "+1", name: "United States" },
  { code: "de", dial: "+49", name: "Deutschland" },
  { code: "fr", dial: "+33", name: "France" },
  { code: "es", dial: "+34", name: "España" },
  { code: "pt", dial: "+351", name: "Portugal" },
  { code: "nl", dial: "+31", name: "Nederland" },
  { code: "be", dial: "+32", name: "Belgique" },
  { code: "ch", dial: "+41", name: "Schweiz" },
  { code: "at", dial: "+43", name: "Österreich" },
  { code: "ie", dial: "+353", name: "Ireland" },
  { code: "gr", dial: "+30", name: "Ελλάδα" },
  { code: "pl", dial: "+48", name: "Polska" },
  { code: "ro", dial: "+40", name: "România" },
  { code: "hr", dial: "+385", name: "Hrvatska" },
  { code: "hu", dial: "+36", name: "Magyarország" },
  { code: "cz", dial: "+420", name: "Česko" },
  { code: "se", dial: "+46", name: "Sverige" },
  { code: "tr", dial: "+90", name: "Türkiye" },
  { code: "br", dial: "+55", name: "Brasil" },
  { code: "in", dial: "+91", name: "India" },
];

/** Compone il numero in E.164: il cliente digita solo il numero nazionale,
 * il prefisso arriva dal selettore con bandierina. Tollera chi incolla il
 * numero completo (+39..., 0039..., o prefisso ripetuto a mano). */
const toE164 = (raw, dial) => {
  let v = (raw || "").replace(/[\s\-.()]/g, "");
  if (!v) return "";
  if (v.startsWith("00")) v = "+" + v.slice(2);
  if (v.startsWith("+")) return v;
  if (v.startsWith(dial.slice(1))) return "+" + v;
  return dial + v;
};

/** Campo telefono con bandierina + prefisso internazionale.
 * onChange riceve SEMPRE il numero completo in formato E.164 (o "" se vuoto). */
export default function PhoneInput({ onChange, className = "", testid = "phone-input", placeholder = "333 123 4567", required = false }) {
  const [country, setCountry] = useState(COUNTRIES[0]);
  const [national, setNational] = useState("");
  const [open, setOpen] = useState(false);

  const pick = (c) => {
    setCountry(c);
    setOpen(false);
    onChange(toE164(national, c.dial));
  };

  const type = (raw) => {
    setNational(raw);
    onChange(toE164(raw, country.dial));
  };

  return (
    <div className={`relative flex items-center ${className}`} data-testid={`${testid}-wrap`}>
      <button type="button" data-testid={`${testid}-prefix`} onClick={() => setOpen((o) => !o)}
        aria-label="Prefisso internazionale"
        className="flex items-center gap-1.5 pl-3 pr-1 py-3 shrink-0 text-sm text-slate-700 hover:text-[#FF6B35] transition-colors">
        <img src={`https://flagcdn.com/w40/${country.code}.png`} alt={country.name} className="w-5 h-[15px] rounded-[3px] object-cover" />
        <span className="font-mono-t font-bold">{country.dial}</span>
        <ChevronDown className={`w-3.5 h-3.5 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <span className="w-px h-5 bg-slate-200 shrink-0" />
      <input data-testid={testid} required={required} type="tel" value={national}
        onChange={(e) => type(e.target.value)} placeholder={placeholder}
        autoComplete="tel-national" inputMode="tel"
        className="flex-1 min-w-0 bg-transparent px-3 py-3 text-sm outline-none" />
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div data-testid={`${testid}-countries`} className="absolute left-0 top-full mt-2 z-20 w-64 max-h-64 overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-xl py-1">
            {COUNTRIES.map((c) => (
              <button key={c.code} type="button" data-testid={`${testid}-country-${c.code}`} onClick={() => pick(c)}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left hover:bg-[#FAF5EE] transition-colors ${c.code === country.code ? "font-bold text-[#FF6B35]" : "text-slate-700"}`}>
                <img src={`https://flagcdn.com/w40/${c.code}.png`} alt="" className="w-5 h-[15px] rounded-[3px] object-cover" />
                <span className="flex-1 truncate">{c.name}</span>
                <span className="font-mono-t text-xs text-slate-400">{c.dial}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
